import {NotificationNumberResolver} from "./notification.resolver";
import {ReferentielCategoriesResolver} from "./pages/administration/categories/enregistrement/admin.categories.resolver";
import {ReferentielAutorisationsResolver} from "./pages/administration/articles/enregistrement/enregistrement.articles.resolver";
import {ResourceMultimediaPipe} from "@utils/image/resource.multimedia.pipe";
import {GestionCategoriesResolver} from "./pages/categories/gestion-categories/gestion.categories.resolver";
import {EnregistrementArticleResolver} from "./pages/administration/articles/enregistrement/enregistrement.articles.resolver";
import {EnregistrementCategorieResolver} from "./pages/administration/categories/enregistrement/enregistrement.categories.resolver";
import {EnregistrementArticleComponent} from "./pages/administration/articles/enregistrement/enregistrement.articles.component";
import {EnregistrementCategorieComponent} from "./pages/administration/categories/enregistrement/enregistrement.categories.component";
import {CategoriesAdminResolver} from "./pages/administration/categories/admin.categories.resolver";
import {ArticlesAdminResolver} from "./pages/administration/articles/admin.articles.resolver";
import {AdminArticleComponent} from "./pages/administration/articles/admin.articles.component";
import {CategoriesComponents} from "./pages/categories/categories.component";
import {CorrespondantDetailsResolver} from "./pages/gestion-panier/correspondant.details.resolver";
import {GestionPanierComponent} from "./pages/gestion-panier/gestion.panier.component";
import {ArticleDetailResolver} from "./pages/categories/article-detail/article.detail.resolver";
import {ArticleDetailComponent} from "./pages/categories/article-detail/article.detail.component";
import {CategorieResolver} from "./pages/categories/gestion-articles/categorie.resolver";
import {GestionArticlesResolver} from "./pages/categories/gestion-articles/gestion.articles.resolver";
import {ArticleComponent} from "./pages/categories/gestion-articles/liste-article/liste.article.component";
import {ListeCategoriesComponent} from "./pages/categories/gestion-articles/liste-categories/liste.categories.component";
import {GestionArticlesComponent} from "./pages/categories/gestion-articles/gestion.articles.component";
import {CategorieComponent} from "./pages/categories/gestion-categories/categorie/categorie.component";
import {GestionCategorieComponent} from "./pages/categories/gestion-categories/gestion.categories.component";
import {HeaderComponent} from "./header/header.component";
import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {CerbaCommonModule} from "@common/cerba-common.module";
import {CerbaPageComponent} from "./cerba.component";
import {MenuComponent} from "./menu/menu.component";
import {AdministrationPageComponent} from "./pages/administration/administration.component";
import {AdminCategorieComponent} from "./pages/administration/categories/admin.categories.component";
import {HistoriquePageComponent} from "./pages/historique/historique.component";
import {HomePageComponent} from "./pages/home/home.component";
import {HistoriqueResolver} from "./pages/historique/historique.resolver";
import {HistoriqueDetailPageComponent} from "./pages/historique-detail/historique-detail.component";
import {HistoriqueDetailResolver} from "./pages/historique-detail/historique-detail.resolver";
import {EnsureUserAuthGuard, LogoutAuthGuard} from "@digicerba/common";
import {AccessResolver} from "./check.resolver";
import { UserAdminAuthGuard } from "./pages/administration/admin.guard";
import { ProfilValideResolver } from "./profil-valide.resolver";

const cerbaRoutes: Routes = [
  {
    path: 'cerba',
    component: CerbaPageComponent,
    canActivate: [EnsureUserAuthGuard],
    resolve: {
      check: AccessResolver,
      nbAlerts: NotificationNumberResolver,
      profilValide: ProfilValideResolver,
    },
    children: [
      { path: 'home', component: HomePageComponent },
      {
        path: 'categories',
        component: CategoriesComponents,
          resolve: {categories: GestionCategoriesResolver},
        children: [
          {path: '', redirectTo: 'liste', pathMatch: 'full'},
          {
            path: 'liste',
            component: GestionCategorieComponent,
          },
          {
            path: 'categorie/:id',
            component: GestionArticlesComponent,
            resolve: {
              articles: GestionArticlesResolver,
              categorie: CategorieResolver
            }
          },
          {
            path: 'article/:id',
            component: ArticleDetailComponent,
            resolve: {
              article: ArticleDetailResolver
            }
          }
        ]
      },
      {
        path: 'administration', component: AdministrationPageComponent,
        canActivate: [UserAdminAuthGuard],
        children: [
          {path: '', redirectTo: 'categories', pathMatch: 'full'},
          {
            path: 'categories', component: AdminCategorieComponent,
            resolve: {categories: CategoriesAdminResolver}
          },
          {
            path: 'articles', component: AdminArticleComponent,
            resolve: {articles: ArticlesAdminResolver}
          },
          {
            path: 'enregistrement',
            children: [
              {
                path: 'categorie', component: EnregistrementCategorieComponent
              },
              {
                path: 'categorie/:id', component: EnregistrementCategorieComponent,
                resolve: {categorie: EnregistrementCategorieResolver}
              },
              {
                path: 'article', component: EnregistrementArticleComponent,
                resolve: {
                  categories: ReferentielCategoriesResolver,
                  autorisations: ReferentielAutorisationsResolver
                }
              },
              {
                path: 'article/:id', component: EnregistrementArticleComponent,
                resolve: {
                  article: EnregistrementArticleResolver,
                  categories: ReferentielCategoriesResolver,
                  autorisations: ReferentielAutorisationsResolver
                }
              }
            ]
          }
        ]
      },
      {
        path: 'historique',
        component: HistoriquePageComponent,
        resolve: {
          historique: HistoriqueResolver
       }
     },
      {
        path: 'historique/:id',
        component: HistoriqueDetailPageComponent,
        resolve: {
          detail: HistoriqueDetailResolver
       }
      },
      {
        path: 'panier',
        component: GestionPanierComponent,
        resolve: {
          panier: CorrespondantDetailsResolver
        }
      },
      { path: '', redirectTo: 'categories', pathMatch: 'full' }
    ]
  },
  {path: 'logout', component: CerbaPageComponent, canActivate: [LogoutAuthGuard]},
  {path: '', redirectTo: 'cerba', pathMatch: 'full'}
];

@NgModule({
  declarations: [
    MenuComponent,
    HeaderComponent,
    CategoriesComponents,
    CerbaPageComponent,
    AdministrationPageComponent,
    HistoriquePageComponent,
    HistoriqueDetailPageComponent,
    GestionCategorieComponent,
    GestionArticlesComponent,
    GestionPanierComponent,
    CategorieComponent,
    ListeCategoriesComponent,
    ArticleComponent,
    ArticleDetailComponent,
    HomePageComponent,
    AdminCategorieComponent,
    AdminArticleComponent,
    EnregistrementCategorieComponent,
    EnregistrementArticleComponent
  ],
  imports: [
    CerbaCommonModule,
    RouterModule.forRoot(cerbaRoutes, {useHash: true})
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AccessResolver,
    GestionCategoriesResolver,
    CategorieResolver,
    GestionArticlesResolver,
    ArticleDetailResolver,
    CorrespondantDetailsResolver,
    CategoriesAdminResolver,
    ArticlesAdminResolver,
    EnregistrementCategorieResolver,
    EnregistrementArticleResolver,
    ReferentielCategoriesResolver,
    ReferentielAutorisationsResolver,
    ResourceMultimediaPipe,
    HistoriqueResolver,
    HistoriqueDetailResolver,
    NotificationNumberResolver,
    UserAdminAuthGuard,
    ProfilValideResolver
  ]

})
export class CerbaRoutingModule { }



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/cerba.router.ts